import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { ShieldOff } from "lucide-react";

/**
 * Global banner for users whose account was suspended while they had a
 * valid token in localstorage / cookie. Shown above the entire app.
 */
export default function SuspendedBanner() {
    const { suspendedInfo, logout, clearSuspended } = useAuth();
    const navigate = useNavigate();
    if (!suspendedInfo) return null;

    const onAcknowledge = async () => {
        await logout();
        clearSuspended();
        navigate("/login");
    };

    return (
        <div
            data-testid="suspended-banner"
            className="fixed top-0 left-0 right-0 z-[60] bg-ember-orange text-white shadow-lg"
            role="alert"
        >
            <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-4 flex-wrap">
                <div className="flex items-start gap-3 min-w-0">
                    <ShieldOff className="w-5 h-5 shrink-0 mt-0.5" />
                    <div className="min-w-0">
                        <div className="font-bold text-sm">
                            {suspendedInfo.message || "Your account has been suspended."}
                        </div>
                        {suspendedInfo.reason && (
                            <div className="text-xs opacity-90 mt-0.5">
                                Reason: {suspendedInfo.reason}
                            </div>
                        )}
                    </div>
                </div>
                <button
                    data-testid="suspended-banner-ack"
                    onClick={onAcknowledge}
                    className="px-3 py-1.5 rounded-md bg-white text-ember-orange text-xs font-bold hover:bg-alpine-mist transition-colors shrink-0"
                >
                    Sign out
                </button>
            </div>
        </div>
    );
}
